const genericSubjects = new Set([
  "meine antwort", "my reply", "antwort", "reply", "rückmeldung", "response",
  "neue anfrage", "new request", "neue nachricht", "new message",
]);

const clean = (value) => String(value || "").replace(/\s+/g, " ").trim();

const shortened = (value, limit = 78) => {
  const text = clean(value);
  return text.length <= limit ? text : `${text.slice(0, limit - 1).trimEnd()}…`;
};

const participantMessages = (request) => (request.messages || []).filter((message) => (
  message.type !== "system"
  && ["player", "admin", "care_manager"].includes(message.sender_role)
  && clean(message.text)
));

export function playerRequestTitle(request, t, { truncate = true } = {}) {
  const display = truncate ? shortened : clean;
  const domainTitle = clean(request.linked_service?.title || request.context?.title);
  if (domainTitle) return display(domainTitle);
  const subject = clean(request.subject);
  if (subject && !genericSubjects.has(subject.toLowerCase())) return display(subject);
  const firstMessage = participantMessages(request)[0];
  return display(firstMessage?.text) || t("requestGenericTopic");
}

export function playerRequestStatusKey(request) {
  if (request.status === "resolved" || request.player_state === "completed") return "completed";
  const messages = participantMessages(request);
  const latest = messages[messages.length - 1];
  if (request.player_state === "response_requested") return "response_requested";
  if (request.player_state === "new_reply") return "new_reply";
  if (latest?.sender_role === "player" && messages.some((message) => (
    ["admin", "care_manager"].includes(message.sender_role)
  ))) return "care_reply_pending";
  return "care_working";
}
